import React from 'react';
import UserNameComponent from '../../../../Elements/UserNameComponent';

const MGR_COLORS = ['#1e4164', '#6699cc', '#7961aa', '#6d8237', '#ef4123', '#f79321'];

function OgManagerCard({ role, userId, colorIndex }) {
  return (
    <div className="og-mgr">
      <span className="av" style={{ background: MGR_COLORS[colorIndex % MGR_COLORS.length] }}>
        <i className="fa-solid fa-user" />
      </span>
      <div className="mx">
        <span className="role">{role}</span>
        <span className="name">
          <UserNameComponent userId={userId} />
        </span>
      </div>
    </div>
  );
}

export default OgManagerCard;
